import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownList,
  Input,
  ToastMessage
} from '@cokitchen/cokitchen-components';
import React, { useEffect, useState } from 'react';
import './styles.scss';
import { ArrowDownIcon } from 'cokitchen-icons';
import MetadataTag from 'components/base/metadata-tag';
import { Link, useNavigate } from 'react-router-dom';
import useInventoryRequestContext, { IRequest } from 'contexts/inventory-stock.context/context';
import useDashboardContext from 'contexts/dashboard.context';
import ActivityIndicator from 'components/base/loader/activityIndicator';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';

const isKeyOfRequest = (key: string): key is keyof IRequest => {
  return ['name', 'quantity', 'vendor'].includes(key);
};

// const getDefRequest = (): IRequest => {
//   return {
//     id: '',
//     name: '',
//     quantity: '0',
//     vendor: {
//       id: '',
//       name: '',
//       price: ''
//     },
//     measurement: weightMeasurement[0].value
//   };
// };

interface IRequestFormFields {
  request: IRequest;
  setRequest: (request: IRequest) => void;
  handleDelete: () => void;
  className: string;
}

const RequestFormFields = (props: IRequestFormFields) => {
  const { request, setRequest, handleDelete, className } = props;
  const { selectedRequests } = useInventoryRequestContext();
  const [isFetchingVendorIngredients, setIsFetchingVendorIngredients] = useState(false);
  const [vendorIngredients, setVendorIngredients] = useState<
    { id: string; name: string; price: string; unit_type: string; vendor_id: string }[]
  >([]);
  const { formVendorsList } = useDashboardContext();
  const getVendorNameAndPrice = (id: string) => formVendorsList?.find((vendor) => vendor.id === id);

  const fetchVendorIngredients = async (id: string) => {
    try {
      setIsFetchingVendorIngredients(true);
      const response = await apiService.get(`vendors/ingredients?ingredient_id=${id}`);
      if (response) {
        setVendorIngredients(
          response?.data?.results.map((vendor_ingredient: any) => {
            return {
              id: vendor_ingredient.id,
              name: vendor_ingredient.ingredient.name,
              price: '₦ ' + Number(vendor_ingredient.gram_price).toLocaleString(),
              unit_type: vendor_ingredient.ingredient.unit_type,
              ingredient_id: vendor_ingredient.ingredient_id,
              vendor_id: vendor_ingredient.vendor_id
            };
          })
        );
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error fetching vendor ingredients'}
          type='error'
        />
      );
    } finally {
      setIsFetchingVendorIngredients(false);
    }
  };

  useEffect(() => {
    fetchVendorIngredients(request.id);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    const { name, value } = target;
    if (!isKeyOfRequest(name)) return;

    setRequest({
      ...request,
      [name]: value
    });
  };

  const deleteVendor = () => {
    setRequest({
      ...request,
      vendor: {
        id: '',
        name: '',
        price: ''
      }
    });
  };

  return (
    <div className={`pt-6 ${className}`}>
      <div className='px-7 pb-6 form'>
        <div className='flex justify-between gap-6 flex-wrap mb-6'>
          <div className='w-full md:w-[340px] relative'>
            <Input
              type='text'
              label='Item name'
              name='name'
              className='w-full'
              placeholder='Carb rice and spices'
              value={request.name}
              disabled={
                !selectedRequests.some((selectedItem) => selectedItem.name !== request.name)
              }
              onChange={handleChange}
              inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[44px]'
            />
            {selectedRequests.find((selectedItem) => selectedItem.name !== request.name) && (
              <div
                className='absolute text-[#E60A2B] text-sm flex gap-1 items-center top-0 right-1 cursor-pointer'
                onClick={handleDelete}>
                - <span>Remove item</span>
              </div>
            )}
          </div>
          <div className='w-full md:w-[250px] flex gap-2 relative'>
            <Input
              type='tel'
              label='Quantity'
              name='quantity'
              className='w-full'
              placeholder='00'
              value={request.quantity}
              onChange={handleChange}
              inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[44px]'
            />
            <div className='absolute w-[50px] h-[20px] z-10 rounded-[2px] shadow bottom-[20%] right-[5%]'>
              <div className='h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer measurement_dropdown'>
                <span className='text-[#6F7376] truncate'>{request.measurement}</span>
                {/* <ArrowDownIcon className='w-5 h-5 text-[#96999C]' /> */}
              </div>
              {/* <Dropdown
                content={
                  <div className='h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer measurement_dropdown'>
                    <span className='text-[#6F7376] truncate'>{measurement}</span>
                    <ArrowDownIcon className='w-5 h-5 text-[#96999C]' />
                  </div>
                }>
                <DropdownList>
                  {weightMeasurement.map((item) => (
                    <DropdownItem
                      key={item.value}
                      onClick={() => {
                        setMeasurement(item.name);
                        setRequest({
                          ...request,
                          measurement: item.value
                        });
                      }}>
                      {item.name}
                    </DropdownItem>
                  ))}
                </DropdownList>
              </Dropdown> */}
            </div>
          </div>
        </div>
        <div className='w-full mb-6'>
          <p className='font-medium mb-2'>Vendor</p>
          <Dropdown
            content={
              <div className='flex justify-between items-center bg-[#FAFAFA] border-b-[2px] border-b-[#D5D6D7] min-h-[44px] h-auto px-[14px]'>
                <span className='text-sm text-[#B5B8BA]'>
                  {request.vendor.id ? (
                    <div className='flex gap-2 flex-wrap'>
                      <MetadataTag
                        key={request.vendor.id}
                        name={`${request.vendor.name} (${request.vendor.price})`}
                        onDelete={() => {
                          deleteVendor();
                        }}
                        hasDeleteBtn
                      />
                    </div>
                  ) : (
                    'Select vendor'
                  )}
                </span>
                <ArrowDownIcon className='h-5 w-5 text-[#95999C]' />
              </div>
            }>
            <DropdownList className='vendors-array-container'>
              <div className='overflow-y-scroll h-[257px]'>
                {vendorIngredients?.length === 0 && isFetchingVendorIngredients ? (
                  <div className='py-3'>
                    <ActivityIndicator />
                  </div>
                ) : vendorIngredients?.length > 0 ? (
                  vendorIngredients.map((item) => (
                    <DropdownItem key={item.id}>
                      <div
                        className='flex gap-1 items-center'
                        onClick={() => {
                          setRequest({
                            ...request,
                            vendor: {
                              id: item.vendor_id,
                              name: getVendorNameAndPrice(item.vendor_id)?.name || '',
                              price: item.price
                            }
                          });
                        }}>
                        <Input
                          type='checkbox'
                          className='mr-1'
                          checked={request.vendor.id === item.id}
                          readOnly
                        />
                        <span className='text-[#212224]'>
                          {getVendorNameAndPrice(item.vendor_id)?.name}
                        </span>
                        <div className='bg-[#DCDBD5] w-[5px] h-[5px] rounded-full' />
                        <span className='text-[#6F7376] text-xs'>{item.price}</span>
                      </div>
                    </DropdownItem>
                  ))
                ) : (
                  <div className='py-3'>
                    <h4 className='text-center'>No result</h4>
                  </div>
                )}
                {vendorIngredients?.length > 0 && isFetchingVendorIngredients && (
                  <div className='py-3'>
                    <ActivityIndicator />
                  </div>
                )}
              </div>
            </DropdownList>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

const InventoryRequest = () => {
  const { requests, setRequests, scrollIndex, setScrollIndex, stocksToEdit } =
    useInventoryRequestContext();
  const router = useNavigate();
  const { can } = useRoleContext();
  const canWriteInventoryManagement = can(
    InventoryModule.InventoryManagement,
    RolePermission.Write
  );
  const { setIsBackLink, setBackLinkTitle } = useDashboardContext();

  useEffect(() => {
    setRequests(
      stocksToEdit.map((stockToEdit) => ({
        id: stockToEdit.ingredient_id,
        name: stockToEdit.ingredient.name,
        measurement: '',
        quantity: '',
        vendor: { id: '', name: '', price: '' }
      }))
    );
  }, []);

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to stock');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (scrollIndex !== null) {
        const requestElements = document.getElementsByClassName(
          `request-form-fields${scrollIndex}`
        );

        if (requestElements.length > 0) {
          requestElements[0].scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
      }
    }, 1000);
    return () => {
      setScrollIndex(null);
    };
  }, [scrollIndex]);

  return (
    <div className='ml-2 md:ml-8 request'>
      <h4 className='text-[24px] font-semibold text-[#2E3031]'>Make a request</h4>
      <p className='text-[#6F7376] text-sm mb-8'>
        Inventory running low on selected items? prepare your list
      </p>
      <div className='bg-[#F7F7F8] w-full max-w-[678px] h-auto p-1 flex  justify-center items-center'>
        <div className='bg-white w-full maxw-[670px] h-auto rounded-md  pt-6'>
          <h4 className='font-semibold text-[20px] pl-7'>Make your selections</h4>
          <div>
            {requests.map((item, index) => (
              <RequestFormFields
                request={item}
                className={`request-form-fields${index}`}
                key={index}
                setRequest={(newRequest) => {
                  setRequests(
                    requests.map((req, i) => {
                      if (i === index) return newRequest;
                      return req;
                    })
                  );
                }}
                handleDelete={() => {
                  setRequests(requests.filter((_, i) => i !== index));
                }}
              />
            ))}
          </div>
          <div>
            <h4
              className='ml-7 my-4 text-sm
            '>
              Select items on the stock list to make request
            </h4>
          </div>
          {/* <div
            className='text-[#0080E5] flex items-center gap-[2px] text-sm font-medium cursor-pointer ml-7 my-4'
            onClick={() => setRequests([...requests, getDefRequest()])}>
            <AddIcon className='w-5 h-5' />
            <span>Add item</span>
          </div> */}
          <div className='flex justify-end gap-6 py-7 px-4 md:px-7 items-center border-t-2 border-t-[#F7F7F8]'>
            <Button variant='link' color='gray' small onClick={() => router(-1)}>
              Cancel
            </Button>
            {canWriteInventoryManagement && (
              <Link to={'preview'}>
                <Button variant='block' color='primary' small className='w-[153px]'>
                  Continue
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryRequest;
